export default __webpack_public_path__ + "static/media/man-jumping.aaaa5cde.png";